/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import BaseValidator from 'ember-cp-validations/validators/base';

const MAX_TIME_ON_PAGE_VALUE = 300;
const MIN_TIME_ON_PAGE_VALUE = 0;

const TimeOnPageValue = BaseValidator.extend({
  validate(value, options, model) {
    let validations = model
      .get('selectionState.timeOnPagePredicates')
      .map((timeOnPagePredicate) => {
        let timeOnPageValue = timeOnPagePredicate.get('value');
        if (!timeOnPageValue) {
          return 'Add a time on page value';
        } else if (timeOnPageValue <= MIN_TIME_ON_PAGE_VALUE) {
          return `Time on page must be greater than ${MIN_TIME_ON_PAGE_VALUE} seconds`;
        } else if (timeOnPageValue >= MAX_TIME_ON_PAGE_VALUE) {
          return `Time on page must be less than ${MAX_TIME_ON_PAGE_VALUE} seconds`;
        }
      })
      .compact()
      .uniq();
    if (validations.length > 0) {
      return validations.join(', ');
    }
    return true;
  },
});

TimeOnPageValue.reopenClass({
  getDependentsFor() {
    return ['model.selectionState.timeOnPagePredicates.@each'];
  },
});

export default TimeOnPageValue;
